import React from "react";
import { CustomHistogram } from "./CustomHistogram";
import { setDashboardChart, removeDashboardChart, deleteChart } from "../../services/ChartService";
import { Link } from "react-router-dom";
import * as d3 from "d3";

class PartHistogramPanel extends React.Component {
    constructor(props) {
        super(props);

        // choose data
        let parsedData = [];
        if (props.histogramData.variableType === "DOUBLE") {
            parsedData = props.histogramData.doubleData;
        } else if (props.histogramData.variableType === "LONG"){
            parsedData = props.histogramData.longData;
        } else if (props.histogramData.variableType === "STRING"){
            parsedData = props.histogramData.stringData;
        }

        this.state = {
            jwtToken: props.jwtToken,
            histogramIndex: props.histogramIndex,
            histogramData: props.histogramData,
            rawData: parsedData,
            hideRawData: true
        };
        // binding
        this.toggleRawData = this.toggleRawData.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.addToDashboard = this.addToDashboard.bind(this);
        this.removeFromDashboard = this.removeFromDashboard.bind(this);
        this.updateParent = this.updateParent.bind(this);
    }

    toggleRawData(){
        if (this.state.hideRawData){
            this.setState({hideRawData: false});
        }  else {
            this.setState({hideRawData: true});
        }
    }

    updateParent(){
        this.props.handleUpdate();
    }

    handleDelete(){
        deleteChart(this.state.jwtToken, this.state.histogramData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Histogram removed successfully."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Histogram could not be removed."
                    });
                }
            }
        );
    }

    addToDashboard(){
        setDashboardChart(this.state.jwtToken, this.state.histogramData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Histogram added to dashboard."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Histogram could not be added to dashboard."
                    });
                }
            }
        );
    }

    removeFromDashboard(){
        removeDashboardChart(this.state.jwtToken, this.state.histogramData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Histogram removed from dashboard."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Histogram could not be removed from dashboard."
                    });
                }
            }
        );
    }

    componentDidMount() {
        if (!this.state.rawData || this.state.rawData.length === 0) return;

        var histogram = CustomHistogram(this.state.rawData, {
            width: 800,
            height: 250,
            barLegend: this.state.histogramData.variable,
            xAxisSteps: this.state.histogramData.step,
            xAxisBars: this.state.histogramData.bars,
            xAxisMin: this.state.histogramData.min,
            xAxisMax: this.state.histogramData.max,
            isStringData: this.state.histogramData.variableType === "STRING"
        });

        d3.select("#histogram" + this.state.histogramIndex).html(histogram.outerHTML);
    }

    render() {
        const hasData = this.state.rawData && this.state.rawData.length > 0;

        return (
        <>
            <div id="histogramsContainer" style={{width: "100%" , marginTop:"20px"}}>
                <table style={{border:"1px lightgray solid", width:"100%"}}>
                    <thead>
                        <tr style={{height:"40px", background:"lightgray"}}>
                            <th style={{paddingLeft:"20px"}}>
                                <span>{this.state.histogramData.name}</span>
                                <Link to={"#"}>
                                    <span title="Delete graph"
                                        className="glyphicon glyphicon-trash"
                                        style={{float:"right", marginRight:"15px", marginTop:"2px"}}
                                        onClick={this.handleDelete} />
                                </Link>
                                <Link to={"#"}>
                                    { this.state.histogramData.pinnedToDashboard ?
                                        <span title="Remove this graph from details dashboard"
                                            className="glyphicon glyphicon-bookmark"
                                            style={{float:"right", marginRight:"15px", marginTop:"2px", color:"darkred"}}
                                            onClick={this.removeFromDashboard} /> :
                                        <span title="Show this graph in details dashboard"
                                            className="glyphicon glyphicon-bookmark"
                                            style={{float:"right", marginRight:"15px", marginTop:"2px"}}
                                            onClick={this.addToDashboard} />
                                    }
                                </Link>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{padding: hasData ? "0" : "20px"}}>
                                {!hasData ? (
                                    <div style={{
                                        padding: "14px 18px",
                                        background: "#fffbeb",
                                        border: "1px solid #fde68a",
                                        borderRadius: "6px",
                                        textAlign: "center",
                                        fontSize: "13px",
                                        color: "#92400e"
                                    }}>
                                        <strong>No data available.</strong>
                                    </div>
                                ) : (
                                    <div id={"histogram" + this.state.histogramIndex} />
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {hasData && (
                <>
                    <button style={{marginTop:"10px", marginBottom: "10px", paddingLeft:"30px", paddingRight:"30px"}}
                                    className="btn btn-default" onClick={this.toggleRawData}
                                    title="Show raw data of the histogram">RAW DATA</button>

                    <pre style={{width: "100%"}} hidden={this.state.hideRawData}>
                        {this.state.histogramData.variable + " = " + JSON.stringify(this.state.rawData)}
                    </pre>
                </>
            )}
        </>
        );
    }
}

export default PartHistogramPanel;